<template>
  <div class="capsuleToyNOResult">
    <img src="@images/capsuleToyNOResultConfirm.png" alt="" class="abs confirm" @click="toHeadList">
  </div>
</template>

<script>
import { closePop, showPage } from '@/utils/common.js';

export default {
  methods: {
    showPage,
    closePop,
    toHeadList(){
      this.showPage('HeadList');
      this.closePop();
    }
  }
}
</script>

<style scoped>
.capsuleToyNOResult{ width: 681px; height: 508px; background: url(@images/capsuleToyNOResult.png) no-repeat 0 0;}
.confirm{ top: 339px; left: 161px;}
</style>